// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2LazC","insightsList":"newBusinessInsightsMenu_insightsList__23cz2","active":"newBusinessInsightsMenu_active__2M17a"};